import React from "react";
import Carousel from "react-material-ui-carousel";
import CarouselItem from "./CarouselItem";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./Carousel.css";
// This is for simple display to how works carousel
const simpleItems = [
  {
    title: "Learn a Language. Change a Life.",
    description:
      "NaTakallam offers award-winning, high-quality language learning programs delivered by refugees, for all levels of Arabic, French, Persian and Spanish",
    image:
      "https://cdn.pixabay.com/photo/2013/06/26/12/14/street-sign-141396_1280.jpg",
    link: "/contact",
  },
  {
    title: "Professional translation service",
    description:
      "NaTakallam offers professional translation and transcription services delivered by qualified refugees/displaced persons, overseen by certified copy editors, proofreaders, and project managers.",
    image:
      "https://cdn.pixabay.com/photo/2017/12/10/20/56/feather-3010848_1280.jpg",
    link: "/services/translation",
  },
  {
    title: "Bring NaTakallam to school",
    description:
      "Nine for Mortal Men, doomed to die, One for the Dark Lord on his dark throne In the Land of Mordor.",
    image:
      "https://cdn.pixabay.com/photo/2018/02/07/18/30/people-3137670_1280.jpg",
    link: "/services/academic",
  },
];

const useStyle = makeStyles((theme) => ({
  root: {
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.05)",
    margin: "50px auto",
    [theme.breakpoints.down("sm")]: {
      margin: "10px auto",
    },
  },
}));

const CarouselSlider = () => {
  const classes = useStyle();
  return (
    <Container className={`servicesCarousel ${classes.root}`}>
      <Carousel>
        {simpleItems.map((item, index) => {
          return (
            <CarouselItem
              key={index}
              title={item.title}
              description={item.description}
              imageURL={item.image}
              link={item.link}
            />
          );
        })}
      </Carousel>
    </Container>
  );
};

export default CarouselSlider;
